import { Component, computed, EventEmitter, input, Output, Signal, signal } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { retrieveFileTypeFromS3Url } from '../../../pages/management/accounting/transactions/_helpers/transactions-helpers';
import { calcConditionalEnvBasedUrl } from '../../../pages/management/accounting/transactions/_helpers/localstack-url-helper';

@Component({
  selector: 'app-file-uploaded-type-display',
  imports: [NgOptimizedImage],
  templateUrl: './file-uploaded-type-display.component.html',
  styleUrl: '../../../../static/styles/components/file-preview.scss',
})
export class FileUploadedTypeDisplayComponent {
  hideDelete = input<boolean>(false);
  url = input<string>('');
  @Output() uploadNewReceipt = new EventEmitter();
  @Output() viewReceipt = new EventEmitter();
  isPdf = signal<boolean>(false);
  isImage = signal<boolean>(false);

  // Fixed URL for LocalStack support (computed from url)
  conditionalEnvUrl = computed(() => calcConditionalEnvBasedUrl(this.url()));

  onViewReceipt() {
    this.viewReceipt.emit(true);
  }

  onUploadNewReceipt() {
    this.uploadNewReceipt.emit(true);
  }

  fileTypeIcon: Signal<string | undefined> = computed<string | undefined>(() => {
    const filetype = retrieveFileTypeFromS3Url(this.url());
    if (!this.url()) return '';

    if (filetype === 'pdf') {
      return './assets/icons/pdf-file-icon.svg';
    }
    if (filetype === 'image') {
      return './assets/icons/img-file-icon.svg';
    } else {
      return '';
    }
  });
}
